import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { checkAssetTypeAndCallFunction } from "../../../Js/CheckCorrectAnswers";
import Confirmation from "../../Modal/Confirmation";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { audioVideoSliceActions } from "../../../Store/Slices/AudioVideoSlice";

const presentationAssets = [];
const notForEval = ["REC", "WORD", "RECADV"];
const oneOptType = ["MATCH", "JW", "MC", "RTS"];

const CBTFooterCard = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const navigation = useNavigate();

  // State
  const [alertFlag, setAlertFlag] = useState(false);
  const [correct, setCorrect] = useState(false);
  const [partialCorrect, setPartialCorrect] = useState(false);
  const [submitButton, setSubmitButton] = useState(true);
  const [showAnswer, setShowAnswer] = useState(false);
  const [previousButton, setPreviousButton] = useState(false);
  const [nextButton, setNextButton] = useState(false);
  const [attempStatus, setAttempStatus] = useState(false);
  const [evalAlert, setEvalAlert] = useState(false);
  const [evalAuto, setEvalAuto] = useState(null);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const {
    attempted,
    numberOfAttemptes,
    finish,
    currentAttempt,
    learnerDefaults,
  } = useSelector((state) => state.currentAsset);
  let showAnswerClicked = useSelector((state) => state.currentAsset.showAnswer);

  // Reset all states on load of next asset
  useEffect(() => {
    setShowAnswer(false);
    setSubmitButton(true);
    dispatch(currentAssetSliceActions.setAttempted(false));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(currentAssetSliceActions.setCurrentAttempt(1));
    if (
      props.currentPage + 1 == props.totalPage &&
      userInfo.rolesInfo.title.toLowerCase() !== "learner"
    ) {
      dispatch(currentAssetSliceActions.setFinish(true));
    } else {
      dispatch(currentAssetSliceActions.setFinish(false));
    }
    checkNextButton();
    checkPreviousButton();
    dispatch(currentAssetSliceActions.setOptionWiseAns([]));

    console.log("ignoreNextPre===>", props.ignoreNextPre);
  }, [props.currentPage]);

  useEffect(() => {
    checkNextButton();
  }, [showAnswerClicked]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setDurationFlag(true));
    dispatch(currentAssetSliceActions.startDuration());
  }, [currentAttempt]);

  useEffect(() => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner" && !submitButton) {
      if (!learnerDefaults.showanswerfunctionality) {
        if (props.currentPage + 1 == props.totalPage) {
          dispatch(currentAssetSliceActions.setFinish(true));
        } else {
          setNextButton(true);
        }
      }
    }
  }, [submitButton]);

  // For learners after successful show answer show next or finish button
  useEffect(() => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      if (
        props.currentPage + 1 == props.totalPage &&
        learnerDefaults.showanswerfunctionality &&
        showAnswerClicked
      ) {
        dispatch(currentAssetSliceActions.setFinish(true));
      } else {
        dispatch(currentAssetSliceActions.setFinish(false));
      }
    }
    if (
      userInfo.rolesInfo.title.toLowerCase() == "learner" &&
      props.currentPage + 1 < props.totalPage &&
      showAnswerClicked
    ) {
      checkNextButton();
    }
  }, [showAnswerClicked]);

  // On answer submit
  const submit = async () => {
    let answerStatus = await checkAssetTypeAndCallFunction(
      props.assetType,
      props.evalMode
    );
    console.log("answerStatus", answerStatus);
    setAttempStatus(answerStatus.attempted);
    dispatch(audioVideoSliceActions.setCurrentAudioSrc(null));
    // First check attempted or not
    if (answerStatus.attempted) {
      dispatch(currentAssetSliceActions.stopDuration());
      dispatch(currentAssetSliceActions.setDurationFlag(false));
      dispatch(currentAssetSliceActions.resetDuration());
      if (answerStatus.optionWiseAns) {
        dispatch(
          currentAssetSliceActions.setOptionWiseAns(answerStatus.optionWiseAns)
        );
      }
      // change attempted flag in redux as per user role
      if (
        userInfo.rolesInfo.title.toLowerCase() == "learner" &&
        answerStatus.evalMode == "auto"
      ) {
        if (numberOfAttemptes == currentAttempt) {
          dispatch(currentAssetSliceActions.setAttempted(true));
        } else {
          console.log("answerStatus.score", answerStatus.score);
          if (answerStatus.score < 1) {
            setTimeout(() => {
              dispatch(currentAssetSliceActions.setOptionWiseAns([]));
            }, [1500]);
          }
        }
      } else {
        dispatch(currentAssetSliceActions.setAttempted(true));
      }

      // If answer is correct then directly set finish or next button
      if (+answerStatus.score === 1) {
        setCorrect(true);
        setPartialCorrect(false);
        if (props.currentPage + 1 == props.totalPage) {
          dispatch(currentAssetSliceActions.setFinish(true));
        }
        if (
          userInfo.rolesInfo.title.toLowerCase() == "learner" &&
          props.currentPage + 1 < props.totalPage
        ) {
          setNextButton(true);
        }
        dispatch(currentAssetSliceActions.setAttempted(true));
        setSubmitButton(false);
      } else {
        if (+answerStatus.score == 0) {
          setCorrect(false);
          setPartialCorrect(false);
        } else {
          setCorrect(false);
          setPartialCorrect(true);
        }
        //setCorrect(false);
        // If answer is incorrect increase attempt or set show answer button
        if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
          if (numberOfAttemptes == currentAttempt) {
            setSubmitButton(false);
          }
        } else {
          setSubmitButton(false);
        }
      }

      // Increase current number of attempt
      if (numberOfAttemptes > currentAttempt && +answerStatus.score < 1) {
        dispatch(
          currentAssetSliceActions.setCurrentAttempt(currentAttempt + 1)
        );
      }
    } else {
      dispatch(currentAssetSliceActions.setAttempted(false));
    }
    if (
      userInfo.rolesInfo.title.toLowerCase() == "learner" &&
      answerStatus.evalMode &&
      answerStatus.evalMode == "manual" &&
      answerStatus.attempted
    ) {
      setEvalAlert(true);
      if (notForEval.indexOf(props.assetType) > -1) {
        setEvalAuto("Great!");
      }
    }

    if (
      !answerStatus.evalMode ||
      answerStatus.evalMode == "auto" ||
      !answerStatus.attempted
    ) {
      // Open correct answer or incorrect answer popup
      setAlertFlag(true);
    }
  };

  // Check for showanswer
  const checkShowAnswer = () => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      if (numberOfAttemptes == currentAttempt) {
        setShowAnswer(true);
      }
    } else {
      setShowAnswer(true);
    }
  };

  // Show Answer
  const showAnswerClick = () => {
    setShowAnswer(false);
    dispatch(currentAssetSliceActions.setOptionWiseAns([]));
    dispatch(audioVideoSliceActions.setCurrentAudioSrc(null));
    dispatch(currentAssetSliceActions.setShowAnswer(showAnswer));
  };

  // Check previous button visibility
  const checkPreviousButton = () => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      setPreviousButton(false);
    } else {
      setPreviousButton(props.currentPage + 1 > 1);
    }
  };

  // Check next button visibility
  const checkNextButton = () => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      if (
        props.currentPage < props.totalPage - 1 &&
        learnerDefaults.showanswerfunctionality &&
        showAnswerClicked
      ) {
        setNextButton(true);
      } else {
        setNextButton(false);
      }
    } else {
      setNextButton(props.currentPage < props.totalPage - 1);
    }
  };

  const sentForEvalClose = () => {
    if (props.currentPage < props.totalPage - 1) {
      setNextButton(true);
      setSubmitButton(false);
    } else {
      dispatch(currentAssetSliceActions.setFinish(true));
      setSubmitButton(false);
    }
  };

  return (
    <>
      <Grid
        container
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          flexWrap: "nowrap",
          alignItems: "center",
          px: 6,
        }}
      >
        <Grid item sx={{}}>
          <Grid container sx={{ gap: 3, pt: 1 }}>
            <Grid item>
              <Box sx={{ border: 1, borderColor: "#5f5600ff", borderRadius: 10 }}>
                <Typography
                  sx={{
                    color: "#5f5600ff",
                    padding: 1,
                    fontSize: "0.8rem",
                    textAlign: "center",
                    fontWeight: "400",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                      padding: 2,
                    },
                  }}
                >
                  Page {props.currentPage + 1} | {props.totalPage}
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              {userInfo.rolesInfo.title.toLowerCase() == "learner" &&
                props.evalMode == "auto" && (
                  <Box
                    sx={{ border: 1, borderColor: "#BBB", borderRadius: 10 }}
                  >
                    <Typography
                      sx={{
                        color: "#5f5600ff",
                        padding: 1,
                        fontSize: "0.8rem",
                        textAlign: "center",
                        fontWeight: "400",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                          padding: 2,
                        },
                      }}
                    >
                      Attempt {currentAttempt} | {numberOfAttemptes}
                    </Typography>
                  </Box>
                )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item sx={{}}>
          <Grid
            container
            sx={{ gap: 2, alignItems: "center", paddingTop: 0.8 }}
          >
            <Grid item>
              <Box>
                {previousButton && (
                  <IconButton
                    sx={{ marginTop: "0.2rem" }}
                    disabled={!props.ignoreNextPre}
                    onClick={props.previous}
                  >
                    <NavigateBeforeIcon
                      sx={{
                        fontSize: "2rem",
                        color: "#5f5600ff",
                        "@media (min-width: 1636px)": {
                          fontSize: "3.2rem",
                        },
                      }}
                    />
                  </IconButton>
                )}
              </Box>
            </Grid>
            <Grid item>
              <Box sx={{ borderRadius: 10 }}>
                {!showAnswer &&
                  submitButton &&
                  presentationAssets.indexOf(props.assetType) == -1 && (
                    <Button
                      sx={{
                        width: "10vw",
                        textTransform: "inherit",
                        borderRadius: 10,
                        boxShadow: 3,
                        fontWeight: "600",
                        color: "#5f5600ff",
                        fontSize: "1rem",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                        },
                      }}
                      onClick={submit}
                    >
                      Submit
                    </Button>
                  )}
                {((userInfo.rolesInfo.title.toLowerCase() == "learner" &&
                  learnerDefaults.showanswerfunctionality &&
                  showAnswer) ||
                  (userInfo.rolesInfo.title.toLowerCase() != "learner" &&
                    showAnswer)) &&
                  presentationAssets.indexOf(props.assetType) == -1 && (
                    <Button
                      sx={{
                        width: "10vw",
                        textTransform: "inherit",
                        borderRadius: 10,
                        boxShadow: 3,
                        fontWeight: "600",
                        color: "#5f5600ff",
                        fontSize: "1rem",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                        },
                      }}
                      onClick={showAnswerClick}
                    >
                      Show Answer
                    </Button>
                  )}
              </Box>
            </Grid>
            <Grid item>
              <Box color="#5f5600ff">
                {nextButton && (
                  <IconButton
                    sx={{ marginTop: "0.2rem" }}
                    disabled={!props.ignoreNextPre}
                    onClick={()=>{
                      setNextButton(false);
                      props.next();
                    }}
                  >
                    <NavigateNextIcon
                      sx={{
                        fontSize: "2rem",
                        color: "#5f5600ff",
                        "@media (min-width: 1636px)": {
                          fontSize: "3.2rem",
                        },
                      }}
                    />
                  </IconButton>
                )}
                {finish && (
                  <Button
                    sx={{
                      width: "10vw",
                      textTransform: "inherit",
                      borderRadius: 10,
                      boxShadow: 3,
                      fontWeight: "600",
                      color: "#5f5600ff",
                      fontSize: "1rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                    onClick={() => {
                      props.finishClick("CBT");
                    }}
                  >
                    Finish
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Confirmation
        visible={alertFlag}
        primaryText={
          !attempStatus
            ? oneOptType.indexOf(props.assetType) > -1
              ? "Please attempt"
              : "Please attempt all"
            : correct
            ? "Congratulations !"
            : partialCorrect
            ? "Partially Correct"
            : "Incorrect"
        }
        secondaryText={
          attempStatus && (partialCorrect || !correct) ? "Redo" : ""
        }
        image={correct ? "complete" : "error"}
        alert={true}
        toggleModal={(flag) => setAlertFlag(flag)}
        timeout={4000}
        onClose={() => {
          setTimeout(() => {
            setCorrect(false);
            if (attempted && !correct) {
              checkShowAnswer();
              setAttempStatus(false);
            }
          }, [500]);
        }}
        UX={true}
      ></Confirmation>
      <Confirmation
        visible={evalAlert}
        primaryText={evalAuto ? evalAuto : "Sent for evaluation"}
        image={"complete"}
        alert={true}
        toggleModal={(flag) => setEvalAlert(flag)}
        timeout={3000}
        onClose={() => {
          if (attempted) {
            setAttempStatus(true);
            showAnswerClick();
            sentForEvalClose();
          }
        }}
        UX={true}
      ></Confirmation>
    </>
  );
};

export default CBTFooterCard;
